module.exports = __webpack_public_path__ + "ba4122a8a327c49b3a1f0496c1cc4a8b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-768.webp.png
// module id = 368
// module chunks = 0